export const isoCountriesEn = [
    {
        "value": "GB",
        "label": "United Kingdom"
    },
    {
        "value": "AF",
        "label": "Afghanistan"
    },
    {
        "value": "AX",
        "label": "Åland Islands"
    },
    {
        "value": "AL",
        "label": "Albania"
    },
    {
        "value": "DZ",
        "label": "Algeria"
    },
    {
        "value": "AS",
        "label": "American Samoa"
    },
    {
        "value": "AD",
        "label": "Andorra"
    },
    {
        "value": "AO",
        "label": "Angola"
    },
    {
        "value": "AI",
        "label": "Anguilla"
    },
    {
        "value": "AQ",
        "label": "Antarctica"
    },
    {
        "value": "AG",
        "label": "Antigua and Barbuda"
    },
    {
        "value": "AR",
        "label": "Argentina"
    },
    {
        "value": "AM",
        "label": "Armenia"
    },
    {
        "value": "AW",
        "label": "Aruba"
    },
    {
        "value": "AU",
        "label": "Australia"
    },
    {
        "value": "AT",
        "label": "Austria"
    },
    {
        "value": "AZ",
        "label": "Azerbaijan"
    },
    {
        "value": "BS",
        "label": "Bahamas"
    },
    {
        "value": "BH",
        "label": "Bahrain"
    },
    {
        "value": "BD",
        "label": "Bangladesh"
    },
    {
        "value": "BB",
        "label": "Barbados"
    },
    {
        "value": "BY",
        "label": "Belarus"
    },
    {
        "value": "BE",
        "label": "Belgium"
    },
    {
        "value": "BZ",
        "label": "Belize"
    },
    {
        "value": "BJ",
        "label": "Benin"
    },
    {
        "value": "BM",
        "label": "Bermuda"
    },
    {
        "value": "BT",
        "label": "Bhutan"
    },
    {
        "value": "BO",
        "label": "Bolivia"
    },
    {
        "value": "BQ",
        "label": "Bonaire, Sint Eustatius and Saba"
    },
    {
        "value": "BA",
        "label": "Bosnia and Herzegovina"
    },
    {
        "value": "BW",
        "label": "Botswana"
    },
    {
        "value": "BV",
        "label": "Bouvet Island"
    },
    {
        "value": "BR",
        "label": "Brazil"
    },
    {
        "value": "IO",
        "label": "British Indian Ocean Territory"
    },
    {
        "value": "BN",
        "label": "Brunei Darussalam"
    },
    {
        "value": "BG",
        "label": "Bulgaria"
    },
    {
        "value": "BF",
        "label": "Burkina Faso"
    },
    {
        "value": "BI",
        "label": "Burundi"
    },
    {
        "value": "CV",
        "label": "Cabo Verde"
    },
    {
        "value": "KH",
        "label": "Cambodia"
    },
    {
        "value": "CM",
        "label": "Cameroon"
    },
    {
        "value": "CA",
        "label": "Canada"
    },
    {
        "value": "KY",
        "label": "Cayman Islands"
    },
    {
        "value": "CF",
        "label": "Central African Republic"
    },
    {
        "value": "TD",
        "label": "Chad"
    },
    {
        "value": "CL",
        "label": "Chile"
    },
    {
        "value": "CN",
        "label": "China"
    },
    {
        "value": "CX",
        "label": "Christmas Island"
    },
    {
        "value": "CC",
        "label": "Cocos (Keeling) Islands"
    },
    {
        "value": "CO",
        "label": "Colombia"
    },
    {
        "value": "KM",
        "label": "Comoros"
    },
    {
        "value": "CG",
        "label": "Congo (Republic of the)"
    },
    {
        "value": "CD",
        "label": "Congo (Democratic Republic of the)"
    },
    {
        "value": "CK",
        "label": "Cook Islands"
    },
    {
        "value": "CR",
        "label": "Costa Rica"
    },
    {
        "value": "CI",
        "label": "Côte d'Ivoire"
    },
    {
        "value": "HR",
        "label": "Croatia"
    },
    {
        "value": "CU",
        "label": "Cuba"
    },
    {
        "value": "CW",
        "label": "Curaçao"
    },
    {
        "value": "CY",
        "label": "Cyprus"
    },
    {
        "value": "CZ",
        "label": "Czech Republic"
    },
    {
        "value": "DK",
        "label": "Denmark"
    },
    {
        "value": "DJ",
        "label": "Djibouti"
    },
    {
        "value": "DM",
        "label": "Dominica"
    },
    {
        "value": "DO",
        "label": "Dominican Republic"
    },
    {
        "value": "EC",
        "label": "Ecuador"
    },
    {
        "value": "EG",
        "label": "Egypt"
    },
    {
        "value": "SV",
        "label": "El Salvador"
    },
    {
        "value": "GQ",
        "label": "Equatorial Guinea"
    },
    {
        "value": "ER",
        "label": "Eritrea"
    },
    {
        "value": "EE",
        "label": "Estonia"
    },
    {
        "value": "ET",
        "label": "Ethiopia"
    },
    {
        "value": "FK",
        "label": "Falkland Islands"
    },
    {
        "value": "FO",
        "label": "Faroe Islands"
    },
    {
        "value": "FJ",
        "label": "Fiji"
    },
    {
        "value": "FI",
        "label": "Finland"
    },
    {
        "value": "FR",
        "label": "France"
    },
    {
        "value": "GF",
        "label": "French Guiana"
    },
    {
        "value": "PF",
        "label": "French Polynesia"
    },
    {
        "value": "TF",
        "label": "French Southern Territories"
    },
    {
        "value": "GA",
        "label": "Gabon"
    },
    {
        "value": "GM",
        "label": "Gambia"
    },
    {
        "value": "GE",
        "label": "Georgia"
    },
    {
        "value": "DE",
        "label": "Germany"
    },
    {
        "value": "GH",
        "label": "Ghana"
    },
    {
        "value": "GI",
        "label": "Gibraltar"
    },
    {
        "value": "GR",
        "label": "Greece"
    },
    {
        "value": "GL",
        "label": "Greenland"
    },
    {
        "value": "GD",
        "label": "Grenada"
    },
    {
        "value": "GP",
        "label": "Guadeloupe"
    },
    {
        "value": "GU",
        "label": "Guam"
    },
    {
        "value": "GT",
        "label": "Guatemala"
    },
    {
        "value": "GG",
        "label": "Guernsey"
    },
    {
        "value": "GN",
        "label": "Guinea"
    },
    {
        "value": "GW",
        "label": "Guinea-Bissau"
    },
    {
        "value": "GY",
        "label": "Guyana"
    },
    {
        "value": "HT",
        "label": "Haiti"
    },
    {
        "value": "HM",
        "label": "Heard Island and McDonald Islands"
    },
    {
        "value": "HN",
        "label": "Honduras"
    },
    {
        "value": "HK",
        "label": "Hong Kong"
    },
    {
        "value": "HU",
        "label": "Hungary"
    },
    {
        "value": "IS",
        "label": "Iceland"
    },
    {
        "value": "IN",
        "label": "India"
    },
    {
        "value": "ID",
        "label": "Indonesia"
    },
    {
        "value": "IR",
        "label": "Iran"
    },
    {
        "value": "IQ",
        "label": "Iraq"
    },
    {
        "value": "IE",
        "label": "Ireland"
    },
    {
        "value": "IM",
        "label": "Isle of Man"
    },
    {
        "value": "IL",
        "label": "Israel"
    },
    {
        "value": "IT",
        "label": "Italy"
    },
    {
        "value": "JM",
        "label": "Jamaica"
    },
    {
        "value": "JP",
        "label": "Japan"
    },
    {
        "value": "JE",
        "label": "Jersey"
    },
    {
        "value": "JO",
        "label": "Jordan"
    },
    {
        "value": "KZ",
        "label": "Kazakhstan"
    },
    {
        "value": "KE",
        "label": "Kenya"
    },
    {
        "value": "KI",
        "label": "Kiribati"
    },
    {
        "value": "KW",
        "label": "Kuwait"
    },
    {
        "value": "KG",
        "label": "Kyrgyzstan"
    },
    {
        "value": "LA",
        "label": "Lao People's Democratic Republic"
    },
    {
        "value": "LV",
        "label": "Latvia"
    },
    {
        "value": "LB",
        "label": "Lebanon"
    },
    {
        "value": "LS",
        "label": "Lesotho"
    },
    {
        "value": "LR",
        "label": "Liberia"
    },
    {
        "value": "LY",
        "label": "Libya"
    },
    {
        "value": "LI",
        "label": "Liechtenstein"
    },
    {
        "value": "LT",
        "label": "Lithuania"
    },
    {
        "value": "LU",
        "label": "Luxembourg"
    },
    {
        "value": "MO",
        "label": "Macao"
    },
    {
        "value": "MK",
        "label": "Macedonia"
    },
    {
        "value": "MG",
        "label": "Madagascar"
    },
    {
        "value": "MW",
        "label": "Malawi"
    },
    {
        "value": "MY",
        "label": "Malaysia"
    },
    {
        "value": "MV",
        "label": "Maldives"
    },
    {
        "value": "ML",
        "label": "Mali"
    },
    {
        "value": "MT",
        "label": "Malta"
    },
    {
        "value": "MH",
        "label": "Marshall Islands"
    },
    {
        "value": "MQ",
        "label": "Martinique"
    },
    {
        "value": "MR",
        "label": "Mauritania"
    },
    {
        "value": "MU",
        "label": "Mauritius"
    },
    {
        "value": "YT",
        "label": "Mayotte"
    },
    {
        "value": "MX",
        "label": "Mexico"
    },
    {
        "value": "FM",
        "label": "Micronesia"
    },
    {
        "value": "MD",
        "label": "Moldova"
    },
    {
        "value": "MC",
        "label": "Monaco"
    },
    {
        "value": "MN",
        "label": "Mongolia"
    },
    {
        "value": "ME",
        "label": "Montenegro"
    },
    {
        "value": "MS",
        "label": "Montserrat"
    },
    {
        "value": "MA",
        "label": "Morocco"
    },
    {
        "value": "MZ",
        "label": "Mozambique"
    },
    {
        "value": "MM",
        "label": "Myanmar"
    },
    {
        "value": "NA",
        "label": "Namibia"
    },
    {
        "value": "NR",
        "label": "Nauru"
    },
    {
        "value": "NP",
        "label": "Nepal"
    },
    {
        "value": "NL",
        "label": "Netherlands"
    },
    {
        "value": "NC",
        "label": "New Caledonia"
    },
    {
        "value": "NZ",
        "label": "New Zealand"
    },
    {
        "value": "NI",
        "label": "Nicaragua"
    },
    {
        "value": "NE",
        "label": "Niger"
    },
    {
        "value": "NG",
        "label": "Nigeria"
    },
    {
        "value": "NU",
        "label": "Niue"
    },
    {
        "value": "NF",
        "label": "Norfolk Island"
    },
    {
        "value": "MP",
        "label": "Northern Mariana Islands"
    },
    {
        "value": "NO",
        "label": "Norway"
    },
    {
        "value": "OM",
        "label": "Oman"
    },
    {
        "value": "PK",
        "label": "Pakistan"
    },
    {
        "value": "PW",
        "label": "Palau"
    },
    {
        "value": "PS",
        "label": "Palestine"
    },
    {
        "value": "PA",
        "label": "Panama"
    },
    {
        "value": "PG",
        "label": "Papua New Guinea"
    },
    {
        "value": "PY",
        "label": "Paraguay"
    },
    {
        "value": "PE",
        "label": "Peru"
    },
    {
        "value": "PH",
        "label": "Philippines"
    },
    {
        "value": "PN",
        "label": "Pitcairn"
    },
    {
        "value": "PL",
        "label": "Poland"
    },
    {
        "value": "PT",
        "label": "Portugal"
    },
    {
        "value": "PR",
        "label": "Puerto Rico"
    },
    {
        "value": "QA",
        "label": "Qatar"
    },
    {
        "value": "RE",
        "label": "Réunion"
    },
    {
        "value": "RO",
        "label": "Romania"
    },
    {
        "value": "RU",
        "label": "Russian Federation"
    },
    {
        "value": "RW",
        "label": "Rwanda"
    },
    {
        "value": "BL",
        "label": "Saint Barthélemy"
    },
    {
        "value": "SH",
        "label": "Saint Helena"
    },
    {
        "value": "KN",
        "label": "Saint Kitts and Nevis"
    },
    {
        "value": "LC",
        "label": "Saint Lucia"
    },
    {
        "value": "MF",
        "label": "Saint Martin"
    },
    {
        "value": "PM",
        "label": "Saint Pierre and Miquelon"
    },
    {
        "value": "VC",
        "label": "Saint Vincent and the Grenadines"
    },
    {
        "value": "WS",
        "label": "Samoa"
    },
    {
        "value": "SM",
        "label": "San Marino"
    },
    {
        "value": "ST",
        "label": "Sao Tome and Principe"
    },
    {
        "value": "SA",
        "label": "Saudi Arabia"
    },
    {
        "value": "SN",
        "label": "Senegal"
    },
    {
        "value": "RS",
        "label": "Serbia"
    },
    {
        "value": "SC",
        "label": "Seychelles"
    },
    {
        "value": "SL",
        "label": "Sierra Leone"
    },
    {
        "value": "SG",
        "label": "Singapore"
    },
    {
        "value": "SX",
        "label": "Sint Maarten"
    },
    {
        "value": "SK",
        "label": "Slovakia"
    },
    {
        "value": "SI",
        "label": "Slovenia"
    },
    {
        "value": "SB",
        "label": "Solomon Islands"
    },
    {
        "value": "SO",
        "label": "Somalia"
    },
    {
        "value": "ZA",
        "label": "South Africa"
    },
    {
        "value": "GS",
        "label": "South Georgia and the South Sandwich Islands"
    },
    {
        "value": "KR",
        "label": "South Korea"
    },
    {
        "value": "SS",
        "label": "South Sudan"
    },
    {
        "value": "ES",
        "label": "Spain"
    },
    {
        "value": "LK",
        "label": "Sri Lanka"
    },
    {
        "value": "SD",
        "label": "Sudan"
    },
    {
        "value": "SR",
        "label": "Suriname"
    },
    {
        "value": "SJ",
        "label": "Svalbard and Jan Mayen"
    },
    {
        "value": "SZ",
        "label": "Swaziland"
    },
    {
        "value": "SE",
        "label": "Sweden"
    },
    {
        "value": "CH",
        "label": "Switzerland"
    },
    {
        "value": "SY",
        "label": "Syrian Arab Republic"
    },
    {
        "value": "TW",
        "label": "Taiwan"
    },
    {
        "value": "TJ",
        "label": "Tajikistan"
    },
    {
        "value": "TZ",
        "label": "Tanzania"
    },
    {
        "value": "TH",
        "label": "Thailand"
    },
    {
        "value": "TL",
        "label": "Timor-Leste"
    },
    {
        "value": "TG",
        "label": "Togo"
    },
    {
        "value": "TK",
        "label": "Tokelau"
    },
    {
        "value": "TO",
        "label": "Tonga"
    },
    {
        "value": "TT",
        "label": "Trinidad and Tobago"
    },
    {
        "value": "TN",
        "label": "Tunisia"
    },
    {
        "value": "TR",
        "label": "Turkey"
    },
    {
        "value": "TM",
        "label": "Turkmenistan"
    },
    {
        "value": "TC",
        "label": "Turks and Caicos Islands"
    },
    {
        "value": "TV",
        "label": "Tuvalu"
    },
    {
        "value": "UG",
        "label": "Uganda"
    },
    {
        "value": "UA",
        "label": "Ukraine"
    },
    {
        "value": "AE",
        "label": "United Arab Emirates"
    },
    {
        "value": "US",
        "label": "United States of America"
    },
    {
        "value": "UY",
        "label": "Uruguay"
    },
    {
        "value": "UZ",
        "label": "Uzbekistan"
    },
    {
        "value": "VU",
        "label": "Vanuatu"
    },
    {
        "value": "VA",
        "label": "Vatican City State"
    },
    {
        "value": "VE",
        "label": "Venezuela"
    },
    {
        "value": "VN",
        "label": "Vietnam"
    },
    {
        "value": "VG",
        "label": "Virgin Islands (British)"
    },
    {
        "value": "VI",
        "label": "Virgin Islands (U.S.)"
    },
    {
        "value": "WF",
        "label": "Wallis and Futuna"
    },
    {
        "value": "EH",
        "label": "Western Sahara"
    },
    {
        "value": "YE",
        "label": "Yemen"
    },
    {
        "value": "ZM",
        "label": "Zambia"
    },
    {
        "value": "ZW",
        "label": "Zimbabwe"
    }
];

export const isoNationalitiesEn = [
    {
        "value": "GB",
        "label": "British, UK"
    },
    {
        "value": "AF",
        "label": "Afghan"
    },
    {
        "value": "AX",
        "label": "Åland Island"
    },
    {
        "value": "AL",
        "label": "Albanian"
    },
    {
        "value": "DZ",
        "label": "Algerian"
    },
    {
        "value": "US",
        "label": "American"
    },
    {
        "value": "AS",
        "label": "American Samoan"
    },
    {
        "value": "AD",
        "label": "Andorran"
    },
    {
        "value": "AO",
        "label": "Angolan"
    },
    {
        "value": "AI",
        "label": "Anguillan"
    },
    {
        "value": "AQ",
        "label": "Antarctic"
    },
    {
        "value": "AG",
        "label": "Antiguan or Barbudan"
    },
    {
        "value": "AR",
        "label": "Argentine"
    },
    {
        "value": "AM",
        "label": "Armenian"
    },
    {
        "value": "AW",
        "label": "Aruban"
    },
    {
        "value": "AU",
        "label": "Australian"
    },
    {
        "value": "AT",
        "label": "Austrian"
    },
    {
        "value": "AZ",
        "label": "Azerbaijani, Azeri"
    },
    {
        "value": "BS",
        "label": "Bahamian"
    },
    {
        "value": "BH",
        "label": "Bahraini"
    },
    {
        "value": "BD",
        "label": "Bangladeshi"
    },
    {
        "value": "BB",
        "label": "Barbadian"
    },
    {
        "value": "BL",
        "label": "Barthélemois"
    },
    {
        "value": "LS",
        "label": "Basotho"
    },
    {
        "value": "BY",
        "label": "Belarusian"
    },
    {
        "value": "BE",
        "label": "Belgian"
    },
    {
        "value": "BZ",
        "label": "Belizean"
    },
    {
        "value": "BJ",
        "label": "Beninese, Beninois"
    },
    {
        "value": "BM",
        "label": "Bermudian, Bermudan"
    },
    {
        "value": "BT",
        "label": "Bhutanese"
    },
    {
        "value": "IO",
        "label": "BIOT"
    },
    {
        "value": "GW",
        "label": "Bissau-Guinean"
    },
    {
        "value": "BO",
        "label": "Bolivian"
    },
    {
        "value": "BQ",
        "label": "Bonaire"
    },
    {
        "value": "BA",
        "label": "Bosnian or Herzegovinian"
    },
    {
        "value": "BV",
        "label": "Bouvet Island"
    },
    {
        "value": "BR",
        "label": "Brazilian"
    },
    {
        "value": "VG",
        "label": "British Virgin Island"
    },
    {
        "value": "BN",
        "label": "Bruneian"
    },
    {
        "value": "BG",
        "label": "Bulgarian"
    },
    {
        "value": "BF",
        "label": "Burkinabé"
    },
    {
        "value": "MM",
        "label": "Burmese"
    },
    {
        "value": "BI",
        "label": "Burundian"
    },
    {
        "value": "CV",
        "label": "Cabo Verdean"
    },
    {
        "value": "KH",
        "label": "Cambodian"
    },
    {
        "value": "CM",
        "label": "Cameroonian"
    },
    {
        "value": "CA",
        "label": "Canadian"
    },
    {
        "value": "KY",
        "label": "Caymanian"
    },
    {
        "value": "CF",
        "label": "Central African"
    },
    {
        "value": "TD",
        "label": "Chadian"
    },
    {
        "value": "GG",
        "label": "Channel Island (Guernsey)"
    },
    {
        "value": "JE",
        "label": "Channel Island (Jersey)"
    },
    {
        "value": "CL",
        "label": "Chilean"
    },
    {
        "value": "CN",
        "label": "Chinese"
    },
    {
        "value": "TW",
        "label": "Chinese, Taiwanese"
    },
    {
        "value": "CX",
        "label": "Christmas Island"
    },
    {
        "value": "CC",
        "label": "Cocos Island"
    },
    {
        "value": "CO",
        "label": "Colombian"
    },
    {
        "value": "KM",
        "label": "Comoran, Comorian"
    },
    {
        "value": "CG",
        "label": "Congolese"
    },
    {
        "value": "CD",
        "label": "Congolese"
    },
    {
        "value": "CK",
        "label": "Cook Island"
    },
    {
        "value": "CR",
        "label": "Costa Rican"
    },
    {
        "value": "HR",
        "label": "Croatian"
    },
    {
        "value": "CU",
        "label": "Cuban"
    },
    {
        "value": "CW",
        "label": "Curaçaoan"
    },
    {
        "value": "CY",
        "label": "Cypriot"
    },
    {
        "value": "CZ",
        "label": "Czech"
    },
    {
        "value": "DK",
        "label": "Danish"
    },
    {
        "value": "DJ",
        "label": "Djiboutian"
    },
    {
        "value": "DM",
        "label": "Dominican (Dominica)"
    },
    {
        "value": "DO",
        "label": "Dominican"
    },
    {
        "value": "NL",
        "label": "Dutch, Netherlandic"
    },
    {
        "value": "EC",
        "label": "Ecuadorian"
    },
    {
        "value": "EG",
        "label": "Egyptian"
    },
    {
        "value": "AE",
        "label": "Emirati, Emirian, Emiri"
    },
    {
        "value": "GQ",
        "label": "Equatorial Guinean, Equatoguinean"
    },
    {
        "value": "ER",
        "label": "Eritrean"
    },
    {
        "value": "EE",
        "label": "Estonian"
    },
    {
        "value": "ET",
        "label": "Ethiopian"
    },
    {
        "value": "FK",
        "label": "Falkland Island"
    },
    {
        "value": "FO",
        "label": "Faroese"
    },
    {
        "value": "FJ",
        "label": "Fijian"
    },
    {
        "value": "FI",
        "label": "Finnish"
    },
    {
        "value": "FR",
        "label": "French"
    },
    {
        "value": "GF",
        "label": "French Guianese"
    },
    {
        "value": "PF",
        "label": "French Polynesian"
    },
    {
        "value": "TF",
        "label": "French Southern Territories"
    },
    {
        "value": "GA",
        "label": "Gabonese"
    },
    {
        "value": "GM",
        "label": "Gambian"
    },
    {
        "value": "GE",
        "label": "Georgian"
    },
    {
        "value": "DE",
        "label": "German"
    },
    {
        "value": "GH",
        "label": "Ghanaian"
    },
    {
        "value": "GI",
        "label": "Gibraltar"
    },
    {
        "value": "GR",
        "label": "Greek, Hellenic"
    },
    {
        "value": "GL",
        "label": "Greenlandic"
    },
    {
        "value": "GD",
        "label": "Grenadian"
    },
    {
        "value": "GP",
        "label": "Guadeloupe"
    },
    {
        "value": "GU",
        "label": "Guamanian, Guambat"
    },
    {
        "value": "GT",
        "label": "Guatemalan"
    },
    {
        "value": "GN",
        "label": "Guinean"
    },
    {
        "value": "GY",
        "label": "Guyanese"
    },
    {
        "value": "HT",
        "label": "Haitian"
    },
    {
        "value": "HM",
        "label": "Heard Island or McDonald Islands"
    },
    {
        "value": "HN",
        "label": "Honduran"
    },
    {
        "value": "HK",
        "label": "Hong Kong, Hong Kongese"
    },
    {
        "value": "HU",
        "label": "Hungarian, Magyar"
    },
    {
        "value": "KI",
        "label": "I-Kiribati"
    },
    {
        "value": "IS",
        "label": "Icelandic"
    },
    {
        "value": "IN",
        "label": "Indian"
    },
    {
        "value": "ID",
        "label": "Indonesian"
    },
    {
        "value": "IR",
        "label": "Iranian, Persian"
    },
    {
        "value": "IQ",
        "label": "Iraqi"
    },
    {
        "value": "IE",
        "label": "Irish"
    },
    {
        "value": "IL",
        "label": "Israeli"
    },
    {
        "value": "IT",
        "label": "Italian"
    },
    {
        "value": "CI",
        "label": "Ivorian"
    },
    {
        "value": "JM",
        "label": "Jamaican"
    },
    {
        "value": "JP",
        "label": "Japanese"
    },
    {
        "value": "JO",
        "label": "Jordanian"
    },
    {
        "value": "KZ",
        "label": "Kazakhstani, Kazakh"
    },
    {
        "value": "KE",
        "label": "Kenyan"
    },
    {
        "value": "KN",
        "label": "Kittitian or Nevisian"
    },
    {
        "value": "KW",
        "label": "Kuwaiti"
    },
    {
        "value": "KG",
        "label": "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz"
    },
    {
        "value": "LA",
        "label": "Lao, Laotian"
    },
    {
        "value": "LV",
        "label": "Latvian"
    },
    {
        "value": "LB",
        "label": "Lebanese"
    },
    {
        "value": "LR",
        "label": "Liberian"
    },
    {
        "value": "LY",
        "label": "Libyan"
    },
    {
        "value": "LI",
        "label": "Liechtenstein"
    },
    {
        "value": "LT",
        "label": "Lithuanian"
    },
    {
        "value": "LU",
        "label": "Luxembourg, Luxembourgish"
    },
    {
        "value": "MO",
        "label": "Macanese, Chinese"
    },
    {
        "value": "MK",
        "label": "Macedonian"
    },
    {
        "value": "YT",
        "label": "Mahoran"
    },
    {
        "value": "MG",
        "label": "Malagasy"
    },
    {
        "value": "MW",
        "label": "Malawian"
    },
    {
        "value": "MY",
        "label": "Malaysian"
    },
    {
        "value": "MV",
        "label": "Maldivian"
    },
    {
        "value": "ML",
        "label": "Malian, Malinese"
    },
    {
        "value": "MT",
        "label": "Maltese"
    },
    {
        "value": "IM",
        "label": "Manx"
    },
    {
        "value": "MH",
        "label": "Marshallese"
    },
    {
        "value": "MQ",
        "label": "Martiniquais, Martinican"
    },
    {
        "value": "MR",
        "label": "Mauritanian"
    },
    {
        "value": "MU",
        "label": "Mauritian"
    },
    {
        "value": "MX",
        "label": "Mexican"
    },
    {
        "value": "FM",
        "label": "Micronesian"
    },
    {
        "value": "MD",
        "label": "Moldovan"
    },
    {
        "value": "MC",
        "label": "Monégasque, Monacan"
    },
    {
        "value": "MN",
        "label": "Mongolian"
    },
    {
        "value": "ME",
        "label": "Montenegrin"
    },
    {
        "value": "MS",
        "label": "Montserratian"
    },
    {
        "value": "MA",
        "label": "Moroccan"
    },
    {
        "value": "BW",
        "label": "Motswana, Botswanan"
    },
    {
        "value": "MZ",
        "label": "Mozambican"
    },
    {
        "value": "NA",
        "label": "Namibian"
    },
    {
        "value": "NR",
        "label": "Nauruan"
    },
    {
        "value": "NP",
        "label": "Nepali, Nepalese"
    },
    {
        "value": "NC",
        "label": "New Caledonian"
    },
    {
        "value": "NZ",
        "label": "New Zealand, NZ"
    },
    {
        "value": "NI",
        "label": "Nicaraguan"
    },
    {
        "value": "NG",
        "label": "Nigerian"
    },
    {
        "value": "NE",
        "label": "Nigerien"
    },
    {
        "value": "NU",
        "label": "Niuean"
    },
    {
        "value": "VU",
        "label": "Ni-Vanuatu, Vanuatuan"
    },
    {
        "value": "NF",
        "label": "Norfolk Island"
    },
    {
        "value": "MP",
        "label": "Northern Marianan"
    },
    {
        "value": "NO",
        "label": "Norwegian"
    },
    {
        "value": "OM",
        "label": "Omani"
    },
    {
        "value": "PK",
        "label": "Pakistani"
    },
    {
        "value": "PW",
        "label": "Palauan"
    },
    {
        "value": "PS",
        "label": "Palestinian"
    },
    {
        "value": "PA",
        "label": "Panamanian"
    },
    {
        "value": "PG",
        "label": "Papua New Guinean, Papuan"
    },
    {
        "value": "PY",
        "label": "Paraguayan"
    },
    {
        "value": "PE",
        "label": "Peruvian"
    },
    {
        "value": "PH",
        "label": "Philippine, Filipino"
    },
    {
        "value": "PN",
        "label": "Pitcairn Island"
    },
    {
        "value": "PL",
        "label": "Polish"
    },
    {
        "value": "PT",
        "label": "Portuguese"
    },
    {
        "value": "PR",
        "label": "Puerto Rican"
    },
    {
        "value": "QA",
        "label": "Qatari"
    },
    {
        "value": "RE",
        "label": "Réunionese, Réunionnais"
    },
    {
        "value": "RO",
        "label": "Romanian"
    },
    {
        "value": "RU",
        "label": "Russian"
    },
    {
        "value": "RW",
        "label": "Rwandan"
    },
    {
        "value": "EH",
        "label": "Sahrawi, Sahrawian, Sahraouian"
    },
    {
        "value": "SH",
        "label": "Saint Helenian"
    },
    {
        "value": "LC",
        "label": "Saint Lucian"
    },
    {
        "value": "MF",
        "label": "Saint-Martinoise"
    },
    {
        "value": "PM",
        "label": "Saint-Pierrais or Miquelonnais"
    },
    {
        "value": "VC",
        "label": "Saint Vincentian, Vincentian"
    },
    {
        "value": "SV",
        "label": "Salvadoran"
    },
    {
        "value": "SM",
        "label": "Sammarinese"
    },
    {
        "value": "WS",
        "label": "Samoan"
    },
    {
        "value": "ST",
        "label": "São Toméan"
    },
    {
        "value": "SA",
        "label": "Saudi, Saudi Arabian"
    },
    {
        "value": "SN",
        "label": "Senegalese"
    },
    {
        "value": "RS",
        "label": "Serbian"
    },
    {
        "value": "SC",
        "label": "Seychellois"
    },
    {
        "value": "SL",
        "label": "Sierra Leonean"
    },
    {
        "value": "SG",
        "label": "Singaporean"
    },
    {
        "value": "SX",
        "label": "Sint Maarten"
    },
    {
        "value": "SK",
        "label": "Slovak"
    },
    {
        "value": "SI",
        "label": "Slovenian, Slovene"
    },
    {
        "value": "SB",
        "label": "Solomon Island"
    },
    {
        "value": "SO",
        "label": "Somali, Somalian"
    },
    {
        "value": "ZA",
        "label": "South African"
    },
    {
        "value": "GS",
        "label": "South Georgia or South Sandwich Islands"
    },
    {
        "value": "KR",
        "label": "South Korean"
    },
    {
        "value": "SS",
        "label": "South Sudanese"
    },
    {
        "value": "ES",
        "label": "Spanish"
    },
    {
        "value": "LK",
        "label": "Sri Lankan"
    },
    {
        "value": "SD",
        "label": "Sudanese"
    },
    {
        "value": "SR",
        "label": "Surinamese"
    },
    {
        "value": "SJ",
        "label": "Svalbard"
    },
    {
        "value": "SZ",
        "label": "Swazi"
    },
    {
        "value": "SE",
        "label": "Swedish"
    },
    {
        "value": "CH",
        "label": "Swiss"
    },
    {
        "value": "SY",
        "label": "Syrian"
    },
    {
        "value": "TJ",
        "label": "Tajikistani"
    },
    {
        "value": "TZ",
        "label": "Tanzanian"
    },
    {
        "value": "TH",
        "label": "Thai"
    },
    {
        "value": "TL",
        "label": "Timorese"
    },
    {
        "value": "TG",
        "label": "Togolese"
    },
    {
        "value": "TK",
        "label": "Tokelauan"
    },
    {
        "value": "TO",
        "label": "Tongan"
    },
    {
        "value": "TT",
        "label": "Trinidadian or Tobagonian"
    },
    {
        "value": "TN",
        "label": "Tunisian"
    },
    {
        "value": "TR",
        "label": "Turkish"
    },
    {
        "value": "TM",
        "label": "Turkmen"
    },
    {
        "value": "TC",
        "label": "Turks and Caicos Island"
    },
    {
        "value": "TV",
        "label": "Tuvaluan"
    },
    {
        "value": "VI",
        "label": "U.S. Virgin Island"
    },
    {
        "value": "UG",
        "label": "Ugandan"
    },
    {
        "value": "UA",
        "label": "Ukrainian"
    },
    {
        "value": "UY",
        "label": "Uruguayan"
    },
    {
        "value": "UZ",
        "label": "Uzbekistani, Uzbek"
    },
    {
        "value": "VA",
        "label": "Vatican"
    },
    {
        "value": "VE",
        "label": "Venezuelan"
    },
    {
        "value": "VN",
        "label": "Vietnamese"
    },
    {
        "value": "WF",
        "label": "Wallis and Futuna, Wallisian or Futunan"
    },
    {
        "value": "YE",
        "label": "Yemeni"
    },
    {
        "value": "ZM",
        "label": "Zambian"
    },
    {
        "value": "ZW",
        "label": "Zimbabwean"
    }
];

export const isoCountriesFr = [
    {
        "value": "FR",
        "label": "France"
    },
    {
        "value": "BE",
        "label": "Belgique"
    },
    {
        "value": "CH",
        "label": "Suisse"
    },
    {
        "value": "CA",
        "label": "Canada"
    },
    {
        "value": "GB",
        "label": "Royaume-Uni"
    },
    {
        "value": "AF",
        "label": "Afghanistan"
    },
    {
        "value": "ZA",
        "label": "Afrique du Sud"
    },
    {
        "value": "AL",
        "label": "Albanie"
    },
    {
        "value": "DZ",
        "label": "Algérie"
    },
    {
        "value": "DE",
        "label": "Allemagne"
    },
    {
        "value": "AD",
        "label": "Andorre"
    },
    {
        "value": "AO",
        "label": "Angola"
    },
    {
        "value": "AI",
        "label": "Anguilla"
    },
    {
        "value": "AQ",
        "label": "Antarctique"
    },
    {
        "value": "AG",
        "label": "Antigua-et-Barbuda"
    },
    {
        "value": "SA",
        "label": "Arabie saoudite"
    },
    {
        "value": "AR",
        "label": "Argentine"
    },
    {
        "value": "AM",
        "label": "Arménie"
    },
    {
        "value": "AW",
        "label": "Aruba"
    },
    {
        "value": "AU",
        "label": "Australie"
    },
    {
        "value": "AT",
        "label": "Autriche"
    },
    {
        "value": "AZ",
        "label": "Azerbaïdjan"
    },
    {
        "value": "BS",
        "label": "Bahamas"
    },
    {
        "value": "BH",
        "label": "Bahreïn"
    },
    {
        "value": "BD",
        "label": "Bangladesh"
    },
    {
        "value": "BB",
        "label": "Barbade"
    },
    {
        "value": "BZ",
        "label": "Belize"
    },
    {
        "value": "BJ",
        "label": "Bénin"
    },
    {
        "value": "BM",
        "label": "Bermudes"
    },
    {
        "value": "BT",
        "label": "Bhoutan"
    },
    {
        "value": "BY",
        "label": "Biélorussie"
    },
    {
        "value": "BO",
        "label": "Bolivie"
    },
    {
        "value": "BQ",
        "label": "Bonaire, Saint-Eustache et Saba"
    },
    {
        "value": "BA",
        "label": "Bosnie-Herzégovine"
    },
    {
        "value": "BW",
        "label": "Botswana"
    },
    {
        "value": "BR",
        "label": "Brésil"
    },
    {
        "value": "BN",
        "label": "Brunéi Darussalam"
    },
    {
        "value": "BG",
        "label": "Bulgarie"
    },
    {
        "value": "BF",
        "label": "Burkina Faso"
    },
    {
        "value": "BI",
        "label": "Burundi"
    },
    {
        "value": "KH",
        "label": "Cambodge"
    },
    {
        "value": "CM",
        "label": "Cameroun"
    },
    {
        "value": "CV",
        "label": "Cap-Vert"
    },
    {
        "value": "CL",
        "label": "Chili"
    },
    {
        "value": "CN",
        "label": "Chine"
    },
    {
        "value": "CY",
        "label": "Chypre"
    },
    {
        "value": "VA",
        "label": "Cité du Vatican"
    },
    {
        "value": "CO",
        "label": "Colombie"
    },
    {
        "value": "KM",
        "label": "Comores"
    },
    {
        "value": "CD",
        "label": "Congo (République démocratique du)"
    },
    {
        "value": "CG",
        "label": "Congo (République du)"
    },
    {
        "value": "KR",
        "label": "Corée du Sud"
    },
    {
        "value": "CR",
        "label": "Costa Rica"
    },
    {
        "value": "CI",
        "label": "Côte d'Ivoire"
    },
    {
        "value": "HR",
        "label": "Croatie"
    },
    {
        "value": "CU",
        "label": "Cuba"
    },
    {
        "value": "CW",
        "label": "Curaçao"
    },
    {
        "value": "DK",
        "label": "Danemark"
    },
    {
        "value": "DJ",
        "label": "Djibouti"
    },
    {
        "value": "DM",
        "label": "Dominique"
    },
    {
        "value": "EG",
        "label": "Égypte"
    },
    {
        "value": "AE",
        "label": "Émirats arabes unis"
    },
    {
        "value": "EC",
        "label": "Équateur"
    },
    {
        "value": "ER",
        "label": "Érythrée"
    },
    {
        "value": "ES",
        "label": "Espagne"
    },
    {
        "value": "EE",
        "label": "Estonie"
    },
    {
        "value": "SZ",
        "label": "Eswatini (ex-Swaziland)"
    },
    {
        "value": "US",
        "label": "États-Unis d'Amérique"
    },
    {
        "value": "ET",
        "label": "Éthiopie"
    },
    {
        "value": "FJ",
        "label": "Fidji"
    },
    {
        "value": "FI",
        "label": "Finlande"
    },
    {
        "value": "GA",
        "label": "Gabon"
    },
    {
        "value": "GM",
        "label": "Gambie"
    },
    {
        "value": "GE",
        "label": "Géorgie"
    },
    {
        "value": "GS",
        "label": "Géorgie du Sud et îles Sandwich du Sud"
    },
    {
        "value": "GH",
        "label": "Ghana"
    },
    {
        "value": "GI",
        "label": "Gibraltar"
    },
    {
        "value": "GR",
        "label": "Grèce"
    },
    {
        "value": "GD",
        "label": "Grenade"
    },
    {
        "value": "GL",
        "label": "Groenland"
    },
    {
        "value": "GP",
        "label": "Guadeloupe"
    },
    {
        "value": "GU",
        "label": "Guam"
    },
    {
        "value": "GT",
        "label": "Guatemala"
    },
    {
        "value": "GG",
        "label": "Guernesey"
    },
    {
        "value": "GN",
        "label": "Guinée"
    },
    {
        "value": "GQ",
        "label": "Guinée équatoriale"
    },
    {
        "value": "GW",
        "label": "Guinée-Bissau"
    },
    {
        "value": "GY",
        "label": "Guyana"
    },
    {
        "value": "GF",
        "label": "Guyane française"
    },
    {
        "value": "HT",
        "label": "Haïti"
    },
    {
        "value": "HN",
        "label": "Honduras"
    },
    {
        "value": "HK",
        "label": "Hong Kong"
    },
    {
        "value": "HU",
        "label": "Hongrie"
    },
    {
        "value": "BV",
        "label": "Île Bouvet"
    },
    {
        "value": "CX",
        "label": "Île Christmas"
    },
    {
        "value": "IM",
        "label": "Île de Man"
    },
    {
        "value": "NF",
        "label": "Île Norfolk"
    },
    {
        "value": "AX",
        "label": "Îles Åland"
    },
    {
        "value": "KY",
        "label": "Îles Caïmans"
    },
    {
        "value": "CC",
        "label": "Îles Cocos (Keeling)"
    },
    {
        "value": "CK",
        "label": "Îles Cook"
    },
    {
        "value": "FO",
        "label": "Îles Féroé"
    },
    {
        "value": "HM",
        "label": "Îles Heard et McDonald"
    },
    {
        "value": "FK",
        "label": "Îles Malouines"
    },
    {
        "value": "MP",
        "label": "Îles Mariannes du Nord"
    },
    {
        "value": "MH",
        "label": "Îles Marshall"
    },
    {
        "value": "PN",
        "label": "Îles Pitcairn"
    },
    {
        "value": "SB",
        "label": "Îles Salomon"
    },
    {
        "value": "TC",
        "label": "Îles Turques-et-Caïques"
    },
    {
        "value": "VG",
        "label": "Îles Vierges britanniques"
    },
    {
        "value": "VI",
        "label": "Îles Vierges des États-Unis"
    },
    {
        "value": "IN",
        "label": "Inde"
    },
    {
        "value": "ID",
        "label": "Indonésie"
    },
    {
        "value": "IQ",
        "label": "Irak"
    },
    {
        "value": "IR",
        "label": "Iran"
    },
    {
        "value": "IE",
        "label": "Irlande"
    },
    {
        "value": "IS",
        "label": "Islande"
    },
    {
        "value": "IL",
        "label": "Israël"
    },
    {
        "value": "IT",
        "label": "Italie"
    },
    {
        "value": "JM",
        "label": "Jamaïque"
    },
    {
        "value": "JP",
        "label": "Japon"
    },
    {
        "value": "JE",
        "label": "Jersey"
    },
    {
        "value": "JO",
        "label": "Jordanie"
    },
    {
        "value": "KZ",
        "label": "Kazakhstan"
    },
    {
        "value": "KE",
        "label": "Kenya"
    },
    {
        "value": "KG",
        "label": "Kirghizistan"
    },
    {
        "value": "KI",
        "label": "Kiribati"
    },
    {
        "value": "KW",
        "label": "Koweït"
    },
    {
        "value": "RE",
        "label": "La Réunion"
    },
    {
        "value": "LA",
        "label": "Laos (République démocratique populaire)"
    },
    {
        "value": "LS",
        "label": "Lesotho"
    },
    {
        "value": "LV",
        "label": "Lettonie"
    },
    {
        "value": "LB",
        "label": "Liban"
    },
    {
        "value": "LR",
        "label": "Libéria"
    },
    {
        "value": "LY",
        "label": "Libye"
    },
    {
        "value": "LI",
        "label": "Liechtenstein"
    },
    {
        "value": "LT",
        "label": "Lituanie"
    },
    {
        "value": "LU",
        "label": "Luxembourg"
    },
    {
        "value": "MO",
        "label": "Macao"
    },
    {
        "value": "MK",
        "label": "Macédoine"
    },
    {
        "value": "MG",
        "label": "Madagascar"
    },
    {
        "value": "MY",
        "label": "Malaisie"
    },
    {
        "value": "MW",
        "label": "Malawi"
    },
    {
        "value": "MV",
        "label": "Maldives"
    },
    {
        "value": "ML",
        "label": "Mali"
    },
    {
        "value": "MT",
        "label": "Malte"
    },
    {
        "value": "MA",
        "label": "Maroc"
    },
    {
        "value": "MQ",
        "label": "Martinique"
    },
    {
        "value": "MU",
        "label": "Maurice"
    },
    {
        "value": "MR",
        "label": "Mauritanie"
    },
    {
        "value": "YT",
        "label": "Mayotte"
    },
    {
        "value": "MX",
        "label": "Mexique"
    },
    {
        "value": "FM",
        "label": "Micronésie"
    },
    {
        "value": "MD",
        "label": "Moldavie"
    },
    {
        "value": "MC",
        "label": "Monaco"
    },
    {
        "value": "MN",
        "label": "Mongolie"
    },
    {
        "value": "ME",
        "label": "Monténégro"
    },
    {
        "value": "MS",
        "label": "Montserrat"
    },
    {
        "value": "MZ",
        "label": "Mozambique"
    },
    {
        "value": "MM",
        "label": "Myanmar (Birmanie)"
    },
    {
        "value": "NA",
        "label": "Namibie"
    },
    {
        "value": "NR",
        "label": "Nauru"
    },
    {
        "value": "NP",
        "label": "Népal"
    },
    {
        "value": "NI",
        "label": "Nicaragua"
    },
    {
        "value": "NE",
        "label": "Niger"
    },
    {
        "value": "NG",
        "label": "Nigéria"
    },
    {
        "value": "NU",
        "label": "Nioué"
    },
    {
        "value": "NO",
        "label": "Norvège"
    },
    {
        "value": "NC",
        "label": "Nouvelle-Calédonie"
    },
    {
        "value": "NZ",
        "label": "Nouvelle-Zélande"
    },
    {
        "value": "OM",
        "label": "Oman"
    },
    {
        "value": "UG",
        "label": "Ouganda"
    },
    {
        "value": "UZ",
        "label": "Ouzbékistan"
    },
    {
        "value": "PK",
        "label": "Pakistan"
    },
    {
        "value": "PW",
        "label": "Palaos"
    },
    {
        "value": "PS",
        "label": "Palestine"
    },
    {
        "value": "PA",
        "label": "Panama"
    },
    {
        "value": "PG",
        "label": "Papouasie-Nouvelle-Guinée"
    },
    {
        "value": "PY",
        "label": "Paraguay"
    },
    {
        "value": "NL",
        "label": "Pays-Bas"
    },
    {
        "value": "PE",
        "label": "Pérou"
    },
    {
        "value": "PH",
        "label": "Philippines"
    },
    {
        "value": "PL",
        "label": "Pologne"
    },
    {
        "value": "PF",
        "label": "Polynésie française"
    },
    {
        "value": "PR",
        "label": "Porto Rico"
    },
    {
        "value": "PT",
        "label": "Portugal"
    },
    {
        "value": "QA",
        "label": "Qatar"
    },
    {
        "value": "CF",
        "label": "République centrafricaine"
    },
    {
        "value": "DO",
        "label": "République dominicaine"
    },
    {
        "value": "CZ",
        "label": "République tchèque"
    },
    {
        "value": "RO",
        "label": "Roumanie"
    },
    {
        "value": "RU",
        "label": "Russie"
    },
    {
        "value": "RW",
        "label": "Rwanda"
    },
    {
        "value": "EH",
        "label": "Sahara occidental"
    },
    {
        "value": "BL",
        "label": "Saint-Barthélemy"
    },
    {
        "value": "KN",
        "label": "Saint-Christophe-et-Niévès"
    },
    {
        "value": "SM",
        "label": "Saint-Marin"
    },
    {
        "value": "MF",
        "label": "Saint-Martin"
    },
    {
        "value": "SX",
        "label": "Saint-Martin (partie néerlandaise)"
    },
    {
        "value": "PM",
        "label": "Saint-Pierre-et-Miquelon"
    },
    {
        "value": "VC",
        "label": "Saint-Vincent-et-les-Grenadines"
    },
    {
        "value": "SH",
        "label": "Sainte-Hélène"
    },
    {
        "value": "LC",
        "label": "Sainte-Lucie"
    },
    {
        "value": "SV",
        "label": "Salvador"
    },
    {
        "value": "WS",
        "label": "Samoa"
    },
    {
        "value": "AS",
        "label": "Samoa américaines"
    },
    {
        "value": "ST",
        "label": "Sao Tomé-et-Principe"
    },
    {
        "value": "SN",
        "label": "Sénégal"
    },
    {
        "value": "RS",
        "label": "Serbie"
    },
    {
        "value": "SC",
        "label": "Seychelles"
    },
    {
        "value": "SL",
        "label": "Sierra Leone"
    },
    {
        "value": "SG",
        "label": "Singapour"
    },
    {
        "value": "SK",
        "label": "Slovaquie"
    },
    {
        "value": "SI",
        "label": "Slovénie"
    },
    {
        "value": "SO",
        "label": "Somalie"
    },
    {
        "value": "SD",
        "label": "Soudan"
    },
    {
        "value": "SS",
        "label": "Soudan du Sud"
    },
    {
        "value": "LK",
        "label": "Sri Lanka"
    },
    {
        "value": "SE",
        "label": "Suède"
    },
    {
        "value": "SR",
        "label": "Suriname"
    },
    {
        "value": "SJ",
        "label": "Svalbard et Jan Mayen"
    },
    {
        "value": "SY",
        "label": "Syrie"
    },
    {
        "value": "TJ",
        "label": "Tadjikistan"
    },
    {
        "value": "TW",
        "label": "Taïwan"
    },
    {
        "value": "TZ",
        "label": "Tanzanie"
    },
    {
        "value": "TD",
        "label": "Tchad"
    },
    {
        "value": "TF",
        "label": "Terres australes françaises"
    },
    {
        "value": "IO",
        "label": "Territoire britannique de l'océan Indien"
    },
    {
        "value": "TH",
        "label": "Thaïlande"
    },
    {
        "value": "TL",
        "label": "Timor oriental"
    },
    {
        "value": "TG",
        "label": "Togo"
    },
    {
        "value": "TK",
        "label": "Tokelau"
    },
    {
        "value": "TO",
        "label": "Tonga"
    },
    {
        "value": "TT",
        "label": "Trinité-et-Tobago"
    },
    {
        "value": "TN",
        "label": "Tunisie"
    },
    {
        "value": "TM",
        "label": "Turkménistan"
    },
    {
        "value": "TR",
        "label": "Turquie"
    },
    {
        "value": "TV",
        "label": "Tuvalu"
    },
    {
        "value": "UA",
        "label": "Ukraine"
    },
    {
        "value": "UY",
        "label": "Uruguay"
    },
    {
        "value": "VU",
        "label": "Vanuatu"
    },
    {
        "value": "VE",
        "label": "Venezuela"
    },
    {
        "value": "VN",
        "label": "Viêt Nam"
    },
    {
        "value": "WF",
        "label": "Wallis-et-Futuna"
    },
    {
        "value": "YE",
        "label": "Yémen"
    },
    {
        "value": "ZM",
        "label": "Zambie"
    },
    {
        "value": "ZW",
        "label": "Zimbabwe"
    }
];

export const isoNationalitiesFr = [
    {
        "value": "FR",
        "label": "Française"
    },
    {
        "value": "BE",
        "label": "Belge"
    },
    {
        "value": "CH",
        "label": "Suisse"
    },
    {
        "value": "CA",
        "label": "Canadienne"
    },
    {
        "value": "GB",
        "label": "Britannique"
    },
    {
        "value": "AF",
        "label": "Afghane"
    },
    {
        "value": "AX",
        "label": "Ålandais"
    },
    {
        "value": "AL",
        "label": "Albanaise"
    },
    {
        "value": "DZ",
        "label": "Algérienne"
    },
    {
        "value": "DE",
        "label": "Allemande"
    },
    {
        "value": "VI",
        "label": "Américain des îles Vierges"
    },
    {
        "value": "US",
        "label": "Américaine"
    },
    {
        "value": "AD",
        "label": "Andorrane"
    },
    {
        "value": "AO",
        "label": "Angolaise"
    },
    {
        "value": "AI",
        "label": "Anguillan"
    },
    {
        "value": "AQ",
        "label": "Antarctique"
    },
    {
        "value": "AG",
        "label": "Antiguaise-et-barbudienne"
    },
    {
        "value": "AR",
        "label": "Argentine"
    },
    {
        "value": "AM",
        "label": "Arménienne"
    },
    {
        "value": "AW",
        "label": "Arubain"
    },
    {
        "value": "AU",
        "label": "Australienne"
    },
    {
        "value": "AT",
        "label": "Autrichienne"
    },
    {
        "value": "AZ",
        "label": "Azerbaïdjanaise"
    },
    {
        "value": "BS",
        "label": "Bahamienne"
    },
    {
        "value": "BH",
        "label": "Bahreïnienne"
    },
    {
        "value": "BD",
        "label": "Bangladaise"
    },
    {
        "value": "BB",
        "label": "Barbadienne"
    },
    {
        "value": "BL",
        "label": "Barthélemois"
    },
    {
        "value": "LS",
        "label": "Basotho"
    },
    {
        "value": "BZ",
        "label": "Bélizienne"
    },
    {
        "value": "BJ",
        "label": "Béninoise"
    },
    {
        "value": "BM",
        "label": "Bermudien"
    },
    {
        "value": "BT",
        "label": "Bhoutanaise"
    },
    {
        "value": "BY",
        "label": "Biélorusse"
    },
    {
        "value": "MM",
        "label": "Birmane"
    },
    {
        "value": "GW",
        "label": "Bissau-Guinéen"
    },
    {
        "value": "BO",
        "label": "Bolivienne"
    },
    {
        "value": "BQ",
        "label": "Bonaïrien"
    },
    {
        "value": "BA",
        "label": "Bosnienne-Herzégovinienne"
    },
    {
        "value": "BW",
        "label": "Botswanaise"
    },
    {
        "value": "BV",
        "label": "Bouvetien"
    },
    {
        "value": "BR",
        "label": "Brésilienne"
    },
    {
        "value": "BN",
        "label": "Brunéienne"
    },
    {
        "value": "BG",
        "label": "Bulgare"
    },
    {
        "value": "BF",
        "label": "Burkinabè"
    },
    {
        "value": "BI",
        "label": "Burundaise"
    },
    {
        "value": "KY",
        "label": "Caïmanien"
    },
    {
        "value": "KH",
        "label": "Cambodgienne"
    },
    {
        "value": "CM",
        "label": "Camerounaise"
    },
    {
        "value": "CV",
        "label": "Cap-verdienne"
    },
    {
        "value": "CF",
        "label": "Centrafricaine"
    },
    {
        "value": "CL",
        "label": "Chilienne"
    },
    {
        "value": "CN",
        "label": "Chinoise"
    },
    {
        "value": "CX",
        "label": "Christmas Island – Île Christmas"
    },
    {
        "value": "CY",
        "label": "Chypriote"
    },
    {
        "value": "CC",
        "label": "Cocos Island – Îles Cocos"
    },
    {
        "value": "CO",
        "label": "Colombienne"
    },
    {
        "value": "KM",
        "label": "Comorienne"
    },
    {
        "value": "CG",
        "label": "Congolaise"
    },
    {
        "value": "CD",
        "label": "Congolaise"
    },
    {
        "value": "CK",
        "label": "Cookien"
    },
    {
        "value": "CR",
        "label": "Costaricienne"
    },
    {
        "value": "HR",
        "label": "Croate"
    },
    {
        "value": "CU",
        "label": "Cubaine"
    },
    {
        "value": "CW",
        "label": "Curaçaoan – Curaçéen"
    },
    {
        "value": "DK",
        "label": "Danoise"
    },
    {
        "value": "DJ",
        "label": "Djiboutienne"
    },
    {
        "value": "DO",
        "label": "Dominicaine"
    },
    {
        "value": "DM",
        "label": "Dominicaine"
    },
    {
        "value": "EG",
        "label": "Égyptienne"
    },
    {
        "value": "AE",
        "label": "Émirienne"
    },
    {
        "value": "EC",
        "label": "Équatorienne"
    },
    {
        "value": "ER",
        "label": "Érythréenne"
    },
    {
        "value": "ES",
        "label": "Espagnole"
    },
    {
        "value": "EE",
        "label": "Estonienne"
    },
    {
        "value": "SZ",
        "label": "Eswatinienne"
    },
    {
        "value": "ET",
        "label": "Éthiopienne"
    },
    {
        "value": "FO",
        "label": "Féroïen"
    },
    {
        "value": "FJ",
        "label": "Fidjienne"
    },
    {
        "value": "FI",
        "label": "Finlandaise"
    },
    {
        "value": "GA",
        "label": "Gabonaise"
    },
    {
        "value": "GM",
        "label": "Gambienne"
    },
    {
        "value": "GS",
        "label": "Géorgien du Sud ou Sandwichien du Sud"
    },
    {
        "value": "GE",
        "label": "Géorgienne"
    },
    {
        "value": "GH",
        "label": "Ghanéenne"
    },
    {
        "value": "GI",
        "label": "Gibraltarien"
    },
    {
        "value": "GR",
        "label": "Grecque"
    },
    {
        "value": "GD",
        "label": "Grenadienne"
    },
    {
        "value": "GL",
        "label": "Groenlandais"
    },
    {
        "value": "GP",
        "label": "Guadeloupéen"
    },
    {
        "value": "GU",
        "label": "Guaméen"
    },
    {
        "value": "GT",
        "label": "Guatémaltèque"
    },
    {
        "value": "GG",
        "label": "Guernesiais"
    },
    {
        "value": "GN",
        "label": "Guinéenne"
    },
    {
        "value": "GQ",
        "label": "Guinéenne équatoriale"
    },
    {
        "value": "GF",
        "label": "Guyanais français"
    },
    {
        "value": "GY",
        "label": "Guyanaise"
    },
    {
        "value": "HT",
        "label": "Haïtienne"
    },
    {
        "value": "HN",
        "label": "Hondurienne"
    },
    {
        "value": "HK",
        "label": "Hongkongais"
    },
    {
        "value": "HU",
        "label": "Hongroise"
    },
    {
        "value": "HM",
        "label": "Îles Heard-et-MacDonald"
    },
    {
        "value": "FK",
        "label": "Îles Malouines"
    },
    {
        "value": "TC",
        "label": "Îles Turques-et-Caïques"
    },
    {
        "value": "VG",
        "label": "Îles Vierges britanniques"
    },
    {
        "value": "IN",
        "label": "Indienne"
    },
    {
        "value": "ID",
        "label": "Indonésienne"
    },
    {
        "value": "IQ",
        "label": "Irakienne"
    },
    {
        "value": "IR",
        "label": "Iranienne"
    },
    {
        "value": "IE",
        "label": "Irlandaise"
    },
    {
        "value": "IS",
        "label": "Islandaise"
    },
    {
        "value": "IL",
        "label": "Israélienne"
    },
    {
        "value": "IT",
        "label": "Italienne"
    },
    {
        "value": "CI",
        "label": "Ivoirienne"
    },
    {
        "value": "JM",
        "label": "Jamaïcaine"
    },
    {
        "value": "JP",
        "label": "Japonaise"
    },
    {
        "value": "JE",
        "label": "Jersiais"
    },
    {
        "value": "JO",
        "label": "Jordanienne"
    },
    {
        "value": "KZ",
        "label": "Kazakhstanaise"
    },
    {
        "value": "KE",
        "label": "Kényane"
    },
    {
        "value": "KG",
        "label": "Kirghize"
    },
    {
        "value": "KI",
        "label": "Kiribatienne"
    },
    {
        "value": "KW",
        "label": "Koweïtienne"
    },
    {
        "value": "LA",
        "label": "Laotienne"
    },
    {
        "value": "LV",
        "label": "Lettonne"
    },
    {
        "value": "LB",
        "label": "Libanaise"
    },
    {
        "value": "LR",
        "label": "Libérienne"
    },
    {
        "value": "LY",
        "label": "Libyenne"
    },
    {
        "value": "LI",
        "label": "Liechtensteinoise"
    },
    {
        "value": "LT",
        "label": "Lituanienne"
    },
    {
        "value": "LU",
        "label": "Luxembourgeoise"
    },
    {
        "value": "MO",
        "label": "Macanais"
    },
    {
        "value": "MK",
        "label": "Macédonienne du Nord"
    },
    {
        "value": "YT",
        "label": "Mahorais"
    },
    {
        "value": "MY",
        "label": "Malaisienne"
    },
    {
        "value": "MW",
        "label": "Malawienne"
    },
    {
        "value": "MV",
        "label": "Maldivienne"
    },
    {
        "value": "MG",
        "label": "Malgache"
    },
    {
        "value": "ML",
        "label": "Malienne"
    },
    {
        "value": "MT",
        "label": "Maltaise"
    },
    {
        "value": "IM",
        "label": "Mannois"
    },
    {
        "value": "MP",
        "label": "Mariannais du Nord"
    },
    {
        "value": "MA",
        "label": "Marocaine"
    },
    {
        "value": "MH",
        "label": "Marshallaise"
    },
    {
        "value": "MQ",
        "label": "Martiniquais"
    },
    {
        "value": "MU",
        "label": "Mauricienne"
    },
    {
        "value": "MR",
        "label": "Mauritanienne"
    },
    {
        "value": "MX",
        "label": "Mexicaine"
    },
    {
        "value": "FM",
        "label": "Micronésienne"
    },
    {
        "value": "MD",
        "label": "Moldave"
    },
    {
        "value": "MC",
        "label": "Monégasque"
    },
    {
        "value": "MN",
        "label": "Mongole"
    },
    {
        "value": "ME",
        "label": "Monténégrine"
    },
    {
        "value": "MS",
        "label": "Montserratien"
    },
    {
        "value": "MZ",
        "label": "Mozambicaine"
    },
    {
        "value": "NA",
        "label": "Namibien"
    },
    {
        "value": "NR",
        "label": "Nauruane"
    },
    {
        "value": "NL",
        "label": "Néerlandaise"
    },
    {
        "value": "NC",
        "label": "Néo-Calédonien"
    },
    {
        "value": "NZ",
        "label": "Néo-Zélandaise"
    },
    {
        "value": "NP",
        "label": "Népalais"
    },
    {
        "value": "NI",
        "label": "Nicaraguayenne"
    },
    {
        "value": "NG",
        "label": "Nigériane"
    },
    {
        "value": "NE",
        "label": "Nigérienne"
    },
    {
        "value": "NU",
        "label": "Niuéen"
    },
    {
        "value": "NF",
        "label": "Norfolkien"
    },
    {
        "value": "NO",
        "label": "Norvégienne"
    },
    {
        "value": "OM",
        "label": "Omanaise"
    },
    {
        "value": "UG",
        "label": "Ougandaise"
    },
    {
        "value": "UZ",
        "label": "Ouzbèke"
    },
    {
        "value": "PK",
        "label": "Pakistanaise"
    },
    {
        "value": "PW",
        "label": "Palaosienne"
    },
    {
        "value": "PS",
        "label": "Palestinienne"
    },
    {
        "value": "PA",
        "label": "Panaméenne"
    },
    {
        "value": "PG",
        "label": "Papouasienne"
    },
    {
        "value": "PY",
        "label": "Paraguayenne"
    },
    {
        "value": "PE",
        "label": "Péruvienne"
    },
    {
        "value": "PH",
        "label": "Philippine"
    },
    {
        "value": "PN",
        "label": "Pitcairnais"
    },
    {
        "value": "PL",
        "label": "Polonaise"
    },
    {
        "value": "PF",
        "label": "Polynésien français"
    },
    {
        "value": "PR",
        "label": "Portoricain"
    },
    {
        "value": "PT",
        "label": "Portugaise"
    },
    {
        "value": "QA",
        "label": "Qatarienne"
    },
    {
        "value": "RE",
        "label": "Réunionnais"
    },
    {
        "value": "RO",
        "label": "Roumaine"
    },
    {
        "value": "RU",
        "label": "Russe"
    },
    {
        "value": "RW",
        "label": "Rwandaise"
    },
    {
        "value": "EH",
        "label": "Sahraoui"
    },
    {
        "value": "SH",
        "label": "Saint-Hélènois"
    },
    {
        "value": "KN",
        "label": "Saint-Kittsienne-et-Névicienne"
    },
    {
        "value": "LC",
        "label": "Saint-Lucienne"
    },
    {
        "value": "SM",
        "label": "Saint-Marinaise"
    },
    {
        "value": "MF",
        "label": "Saint-Martinois"
    },
    {
        "value": "SX",
        "label": "Saint-Martinois"
    },
    {
        "value": "PM",
        "label": "Saint-Pierrais ou Miquelonnais"
    },
    {
        "value": "VC",
        "label": "Saint-Vincentaise-et-Grenadine"
    },
    {
        "value": "SB",
        "label": "Salomonaise"
    },
    {
        "value": "SV",
        "label": "Salvadorienne"
    },
    {
        "value": "AS",
        "label": "Samoan américain"
    },
    {
        "value": "WS",
        "label": "Samoane"
    },
    {
        "value": "ST",
        "label": "Santoméenne"
    },
    {
        "value": "SA",
        "label": "Saoudienne"
    },
    {
        "value": "SN",
        "label": "Sénégalaise"
    },
    {
        "value": "RS",
        "label": "Serbe"
    },
    {
        "value": "SC",
        "label": "Seychelloise"
    },
    {
        "value": "SL",
        "label": "Sierra-Léonaise"
    },
    {
        "value": "SG",
        "label": "Singapourienne"
    },
    {
        "value": "SK",
        "label": "Slovaque"
    },
    {
        "value": "SI",
        "label": "Slovène"
    },
    {
        "value": "SO",
        "label": "Somalienne"
    },
    {
        "value": "SD",
        "label": "Soudanaise"
    },
    {
        "value": "LK",
        "label": "Sri-Lankaise"
    },
    {
        "value": "ZA",
        "label": "Sud-Africain"
    },
    {
        "value": "KR",
        "label": "Sud-Coréenne"
    },
    {
        "value": "SS",
        "label": "Sud-Soudanaise"
    },
    {
        "value": "SE",
        "label": "Suédoise"
    },
    {
        "value": "SR",
        "label": "Surinamaise"
    },
    {
        "value": "SJ",
        "label": "Svalbard – Svalbardien"
    },
    {
        "value": "SY",
        "label": "Syrienne"
    },
    {
        "value": "TJ",
        "label": "Tadjike"
    },
    {
        "value": "TW",
        "label": "Taïwanaise"
    },
    {
        "value": "TZ",
        "label": "Tanzanienne"
    },
    {
        "value": "TD",
        "label": "Tchadienne"
    },
    {
        "value": "CZ",
        "label": "Tchèque"
    },
    {
        "value": "TF",
        "label": "Terres australes françaises"
    },
    {
        "value": "IO",
        "label": "Territoires britanniques de l’océan Indien"
    },
    {
        "value": "TH",
        "label": "Thaïlandaise"
    },
    {
        "value": "TL",
        "label": "Timoraise"
    },
    {
        "value": "TG",
        "label": "Togolaise"
    },
    {
        "value": "TK",
        "label": "Tokelauien"
    },
    {
        "value": "TO",
        "label": "Tongienne"
    },
    {
        "value": "TT",
        "label": "Trinidadienne-et-Tobagienne"
    },
    {
        "value": "TN",
        "label": "Tunisienne"
    },
    {
        "value": "TR",
        "label": "Turc"
    },
    {
        "value": "TM",
        "label": "Turkmène"
    },
    {
        "value": "TV",
        "label": "Tuvaluane"
    },
    {
        "value": "UA",
        "label": "Ukrainienne"
    },
    {
        "value": "UY",
        "label": "Uruguayenne"
    },
    {
        "value": "VU",
        "label": "Vanuataise"
    },
    {
        "value": "VA",
        "label": "Vaticane"
    },
    {
        "value": "VE",
        "label": "Vénézuélienne"
    },
    {
        "value": "VN",
        "label": "Vietnamienne"
    },
    {
        "value": "WF",
        "label": "Wallisien ou Futunien"
    },
    {
        "value": "YE",
        "label": "Yéménite"
    },
    {
        "value": "ZM",
        "label": "Zambienne"
    },
    {
        "value": "ZW",
        "label": "Zimbabwéenne"
    }
];